module.exports = __webpack_public_path__ + "img/logo-dark-sm.5c5a2f3c.png";